module.exports = __webpack_public_path__ + "static/media/devices.6c69fcd3.png";